import { defineStore } from 'pinia';

const PPTStore = defineStore(
  'PPTStore',
  () => {
    const curentPPT = ref();

    return {
      curentPPT
    };
  },
  { persist: true }
);

export default PPTStore;
